import { Component, OnInit } from '@angular/core';
import { Cooperation } from '../../models/cooperation';
import { DomSanitizer } from '@angular/platform-browser';
import { Router } from '@angular/router';
import { NbDialogRef } from '@nebular/theme';

@Component({
  selector: 'app-cooperation-details',
  templateUrl: './cooperation-details.component.html',
  styleUrls: ['./cooperation-details.component.scss'],
})
export class CooperationDetailsComponent implements OnInit {
  model = {} as Cooperation;
  constructor(private route: Router,
     private diag: NbDialogRef<CooperationDetailsComponent>, 
     public sanitizer: DomSanitizer) {}

  ngOnInit() {
      this.route.events.subscribe(()=>{
      this.diag.close('false');
     });
  }
  getLabelData(text) {
    return this.sanitizer.bypassSecurityTrustHtml(text);
  }

  close() {
    this.diag.close();
  }
}
